import React from "react";
import { useFormContext } from "react-hook-form";
import { CategoryContainer } from "../../components/CategoryContainer";
import { AutocompleteRHF } from "../../components/RHFWrappedComponents";
import {
  afflitionEntities,
  indirectRelationOptions as affiliationRelationOptions,
} from "../../data";
import { AddAnother } from "../../components/AddAnother";
import { Typography } from "@mui/material";

export function Affiliations() {
  const { getValues } = useFormContext();

  return (
    <CategoryContainer title="Affiliations">
      <Typography variant="body2">
        An affiliation is an organization, group, or company with which you have
        a direct and indirect (via a family member) relationship with.
      </Typography>
      <AddAnother
        arrayName="additionalInfo.affiliations"
        defaultValue={{
          entityName: "",
          directRelation: "",
          indirectRelation: "",
        }}
        renderForm={(i) => (
          <>
            <AutocompleteRHF
              name={`additionalInfo.affiliations.${i}.entityName`}
              options={afflitionEntities}
              selectLabel={"Organization, Group or Company"}
              rules={{
                validate: {
                  ifRelationshipSet: (v: string): boolean | string => {
                    const directRel = getValues(
                      `additionalInfo.affiliations.${i}.directRelation`
                    );
                    const indirectRel = getValues(
                      `additionalInfo.affiliations.${i}.indirectRelation`
                    );
                    if (!directRel && !indirectRel) {
                      // Relation is not set so any value in this field is good
                      return true;
                    }
                    return v !== null && v.length > 0
                      ? true
                      : "Organization, Group or Company is required";
                  },
                },
              }}
            />
            <AutocompleteRHF
              name={`additionalInfo.affiliations.${i}.directRelation`}
              options={affiliationRelationOptions}
              selectLabel={"Relationship to the affiliation"}
              rules={{
                validate: {
                  ifAffiliationEntitySet: (v: string): boolean | string => {
                    const entity = getValues(
                      `additionalInfo.affiliations.${i}.entityName`
                    );
                    if (!entity) {
                      // Relation is not set so any value in this field is good
                      return true;
                    }
                    return v !== null && v.length > 0
                      ? true
                      : "Relationship to the affiliation is required";
                  },
                },
              }}
            />
            <AutocompleteRHF
              name={`additionalInfo.affiliations.${i}.indirectRelation`}
              options={affiliationRelationOptions}
              selectLabel={"Relationship to affiliated person"}
            />
          </>
        )}
      />
    </CategoryContainer>
  );
}
